import { render } from "./LazyImage.vue?vue&type=template&id=5da870c0"
import script from "./LazyImage.vue?vue&type=script&lang=js"
export * from "./LazyImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/LazyImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5da870c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5da870c0', __exports__)) {
    api.reload('5da870c0', __exports__)
  }
  
  module.hot.accept("./LazyImage.vue?vue&type=template&id=5da870c0", () => {
    api.rerender('5da870c0', render)
  })

}


export default __exports__